const faqSearch = {
    input: document.getElementById('jsFaqInput') as HTMLInputElement | null,
    faqs: document.querySelectorAll('.jsFaqValue') as NodeListOf<HTMLElement>,

    init() {
        this.setFaqSearch();
    },

    setFaqSearch() {
        if (!this.input) return;

        if(this.input) {
        this.input.addEventListener('input', (event: Event) => {
            const target = event.currentTarget as HTMLInputElement;
            const inputValue = target.value.toLowerCase().trim();

            this.faqs.forEach((faq) => {
                const getDataset = (faq.dataset.value ?? '').toLowerCase();

                if (inputValue === '') {
                    faq.classList.remove('d-none');
                    return;
                }

                const words = inputValue.split(/\s+/);
                const matchAllWords = words.every((word) => getDataset.includes(word));

                faq.classList.toggle('d-none', !matchAllWords);
            });
        });

    }
    },
};

export default faqSearch;